'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _LoginModal = _interopRequireDefault(require("Modals/LoginModal"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FriseIcon = _interopRequireDefault(require("Icons/FriseIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class RessourcesPage extends _react.Component {
  state = {
    loading: false,
    blogs: [],
    blogs_count: 0,
    searched_title: '',
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchBlogs({});
  }
  fetchBlogs = ({
    page,
    order,
    order_by,
    searched_title
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    component.setState({
      loading: true
    });
    console.log(searched_title);
    qwest.post('/blog/get-all', {
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      searched_title: searched_title || state.searched_title,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        blogs: response.blogs,
        blogs_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      searched_title: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchBlogs({
        searched_title: value
      });
    }, 800);
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchBlogs({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let role = app.state.session?.user?.roles[0];
    let ressources;
    if (role === "company" || role === "candidate") {
      ressources = (state.blogs || []).filter(ressource => ressource.visibility === true || ressource.category === role);
    } else {
      ressources = (state.blogs || []).filter(ressource => ressource.visibility === true);
    }
    ressources = (ressources || []).map(function (blog) {
      let visibility_className;
      blog?.visibility === false ? visibility_className = "c-blog-item--private" : visibility_className = "";
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item " + visibility_className,
        key: blog.id
      }, /*#__PURE__*/_react.default.createElement(_Image.default, {
        className: "c-blog-item__image",
        src: blog.images?.[0]?.url,
        alt: blog.title
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-blog-item__title"
      }, blog.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-blog-item__txt",
        dangerouslySetInnerHTML: {
          __html: blog.description
        }
      }), /*#__PURE__*/_react.default.createElement("a", {
        className: "c-blog-item__file",
        href: blog.documents[0]?.url,
        target: "_blank"
      }, "T\xE9l\xE9charger le document"), blog?.youtube_link && blog?.youtube_link !== "" ? /*#__PURE__*/_react.default.createElement("a", {
        href: blog?.youtube_link,
        className: "c-blog-item__file",
        target: "_blank"
      }, "Voir la vid\xE9o") : undefined);
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Ressources | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title u-text-center u-margin-bottom-0"
    }, "Ressources"), /*#__PURE__*/_react.default.createElement("p", {
      className: "u-text-center u-bold u-margin-top-0"
    }, "D\xE9couvrez tous nos contenus \xE0 t\xE9l\xE9charger"), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "c-blog-search",
      name: "searched_title",
      label: "Rechercher",
      status: state.status_messages,
      value: state.searched_title
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-blog-list"
    }, ressources)));
    return output;
  }
}
exports.default = RessourcesPage;
